import { OrderItem } from '../../types';
import { filterAnySupplierItems } from './filterAnySupplierItems';
import {getAllOrderItemsTotal} from './getAllOrderItemsTotal';

export function getAllSupplierItemsTotal(orderItems : OrderItem[]) : string {

    return getAllOrderItemsTotal(filterAnySupplierItems(orderItems));

}
